import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-bar-chart-square-02',
  imports: [],
  templateUrl: './bar-chart-square-02.html',
  styleUrl: './bar-chart-square-02.scss',
})
export class BarChartSquare02 {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
